export default __webpack_public_path__ + "static/media/avatar_177.259cadc1.png";